import { Component, OnInit, Injectable, Inject, Optional, ViewChild, ElementRef, HostListener, Injector, OnDestroy } from '@angular/core';
import { BaseComponent } from './shared/components/base/base.component';
import { CommonService } from './core/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { Message } from './core/class/message';
import { NavigationEnd, Router } from '@angular/router';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import localeEn from '@angular/common/locales/en';
import localeVi from '@angular/common/locales/vi';
import localeViExtra from '@angular/common/locales/extra/vi';
import { registerLocaleData } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { DateFormat } from './core/class/date-format';
import { AuthenticationService } from './core/services/authentication.service';
import { MessagingService } from './core/services/messaging-service';
import { ToastrService } from 'ngx-toastr';
import { EnvService } from './core/services/env.service';
import { debounceTime, filter } from 'rxjs/operators';
import { MultiDownloadService } from './core/services/multi-download.service';
import { DocumentService } from './core/services/document.service';
import { DocumentMohaService } from './core/services/document-moha.service';
import { EnumDownloadMenuName } from './core/constants/common';
import { Subscription } from 'rxjs';
import { NotificationCmsService } from './core/services/notification-cms.service';
import { environment } from 'src/environments/environment';
import { AnalyticService } from './core/services/google-analytics.service';
import localeZh from '@angular/common/locales/zh';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEn, 'en');
registerLocaleData(localeVi, 'vi', localeViExtra);
registerLocaleData(localeZh, 'zh');
registerLocaleData(localeEs, 'es');

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MM YYYY',
  },
};

export let InjectorInstant: Injector;
export let PRIMARY_COLOR = '#ee0033';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    // DateFormat,
    { provide: MAT_DATE_LOCALE, useValue: 'vi' },
    {
      provide: DateAdapter,
      useClass: DateFormat,
      deps: [MAT_DATE_LOCALE, Platform],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class AppComponent extends BaseComponent implements OnInit, OnDestroy {
  title = 'viettel-scontract-app';
  msg: any;
  isFromSSO = false;
  isNotAttestedUser = false;
  @ViewChild('headerIframe', { static: false }) headerIframe: ElementRef<HTMLIFrameElement>;

  subscribeMultiDownloadService: Subscription;
  subscribeOpenDownloadService: Subscription;
  apiMultiDownloadService: Subscription;
  isDownloadPopup = false;
  nameMenu = '';
  downloadIds: string[] = [];
  isEmployeeDownload = false;
  employeeName = '';
  employeeProfileCount = 0;
  isLaborContractDownload = false;
  laborContractName = '';

  @HostListener('window:storage', ['$event'])
  changeLocalStorage(e: StorageEvent) {
    if (e.key === 'entType')
      this.commonService.entTypeChange.next(true);
  }

  /**
   * <pre>
   * <b>Method name: constructor</b>
   * <b>Explanation: </b> Method constructor
   * </pre>
   * @author GCS 2019/08/25 by phuongtq
   *
   */
  constructor(
    private router: Router,
    commonService: CommonService,
    private translate: TranslateService,
    message: Message,
    private authService: AuthenticationService,
    private _adapter: DateAdapter<any>,
    private messagingService: MessagingService,
    private auth: AuthenticationService,
    private toastr: ToastrService,
    private env: EnvService,
    private injector: Injector,
    public notificationCmsService: NotificationCmsService,
    private downloadService: MultiDownloadService,
    private documentService: DocumentService,
    private documentMohaService: DocumentMohaService,
    private analytics: AnalyticService,
  ) {
    super(commonService, message);
    InjectorInstant = this.injector
    this.commonService.entTypeChange.pipe(debounceTime(500)).subscribe(() => {
      this.setTheme();
    })
    this.setDefaultLanguage();
    this.isNotAttestedUser = this.commonService.checkEnterpriseType()
    // Ask other tabs for session storage (this is ONLY to trigger event)
    if (!sessionStorage.length) {
      localStorage.setItem('getSessionStorage', 'tmp');
      localStorage.removeItem('getSessionStorage');
    }
    const ssoHost = env.sme_portal_url;
    localStorage.setItem('ssoHost', ssoHost);
    // handle in case user manually input invalid character to url
    // Comment for bug SCONTRACT-5107 - if have any problem about security, please discuss
    // this.router.events.pipe(filter((event: any) => event instanceof NavigationStart))
    //   .subscribe((data: NavigationStart) => {
    //       if (data.url) {
    //         if (data.url.indexOf('%3C') > 0) {
    //           this.router.navigate(['/404']);
    //         }
    //       }
    //   });
    analytics.getGaMeasurementId().subscribe(res => {
      if (res.success) {
        analytics.loadGoogleAnalytics(res.data.value)
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
          this.analytics.sendPageView(event.urlAfterRedirects, res.data.value);
        });
      } else {
        toastr.error(res.message)
      }
    })

  }

  setTheme() {
    document.documentElement.style.removeProperty('--primary-color');
    if (this.commonService.checkEnterpriseType()) {
      PRIMARY_COLOR = '#CE002B';
    } else {
      PRIMARY_COLOR = '#ee0033';
    }
    document.documentElement.style.setProperty('--primary-color', PRIMARY_COLOR);
  }
  /**
   * <pre>
   * <b>Method name: setDefaultLanguage</b>
   * <b>Explanation: </b> Method setting default langauge
   * </pre>
   * @author GCS 2019/08/25 by phuongqt
   *
   */
  setDefaultLanguage() {
    if (this.getLanguagelocalStored() === null) {
      this.translate.setDefaultLang('vi');
      this.setLanguagelocalStored('vi');
      this._adapter.setLocale('vi');
    } else {
      this.translate.setDefaultLang(this.getLanguagelocalStored());
      this._adapter.setLocale(this.getLanguagelocalStored());
    }
  }

  async ngOnInit() {
    this.messagingService.requestPermission();
    this.messagingService.receiveMessaging();
    this.messagingService.listenIdChange();
    this.msg = this.messagingService.currentMessage;
    window.addEventListener('message', this.receiveMessage.bind(this));
    if (sessionStorage.getItem('isChangeMode')) {
      this.toastr.success(
        this.commonService.format(await this.commonService.getMessage('select_version.message.change_mode_success'), this.isNotAttestedUser ? 'sContract' : 'vContract')
      )
      sessionStorage.removeItem('isChangeMode')
      this.notificationCmsService.getNotification();

    }
    if (sessionStorage.getItem('isChangeDefaultMode')) {
      this.toastr.success(await this.commonService.getMessage('select_version.message.change_default_mode_success'))
      sessionStorage.removeItem('isChangeDefaultMode')
    }

    // set up multi download
    this.subscribeMultiDownloadService = this.downloadService.connect().subscribe(data => {
      if (Object.keys(data).length > 0) {
        if (data.hasOwnProperty('contractIds')) {
          this.downloadIds = data.contractIds;
        }
        this.setNameMenu(data.menuContract);

        if (data.menuContract === EnumDownloadMenuName.VIEW_EMPLOYEE_LIST) {
          this.isEmployeeDownload = true;
          this.isLaborContractDownload = false;
          this.employeeName = data.employeeName || '';
          this.employeeProfileCount = data.employeeProfileCount || 1;
          this.downloadService.setOpen(true);

          const employeeId = (data.contractIds && data.contractIds.length > 0) ? data.contractIds[0] : '';
          this.apiMultiDownloadService = this.documentMohaService.getContractFilesZipByEmployee(employeeId).subscribe(res => {
            if (res) {
              if (res.success === false || res.status === false || (res.code && res.code != '200' && res.code != 200)) {
                this.downloadService.setOpen(false);
                this.toastr.error(res.message || res.error || 'Tải file không thành công');
                return;
              }

              const downloadKey = typeof res === 'string' ? res : (res.key || res.data);
              if (!downloadKey || typeof downloadKey !== 'string') {
                this.downloadService.setOpen(false);
                this.toastr.error(res.message || 'Không thể lấy mã tải file');
                return;
              }

              const body = {
                key: downloadKey,
                token: sessionStorage.getItem('token'),
                lang: localStorage.getItem('__language')
              };

              this.documentMohaService.downloadFileZipBHS(body).subscribe(rs => {
                this.downloadService.setOpen(false);
                if (rs && rs.body) {
                  if (rs.body.type === 'application/json') {
                    const reader = new FileReader();
                    reader.onload = () => {
                      try {
                        const errorRes = JSON.parse(reader.result as string);
                        this.toastr.error(errorRes.message || 'Lỗi tải file');
                      } catch (e) {
                        this.toastr.error('Lỗi tải file');
                      }
                    };
                    reader.readAsText(rs.body);
                    return;
                  }

                  const blob = rs.body;
                  const disposition = rs.headers.get('content-disposition');
                  const fileName = this.getFileName(disposition) || 'download.zip';

                  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                    return;
                  }

                  const url = URL.createObjectURL(blob);
                  const anchor = document.createElement('a');

                  anchor.href = url;
                  anchor.download = fileName;
                  anchor.style.display = 'none';

                  document.body.appendChild(anchor);
                  anchor.click();
                  anchor.remove();

                  URL.revokeObjectURL(url);
                }
              }, err => {
                this.downloadService.setOpen(false);
                this.toastr.error(err && err.message ? err.message : 'Error downloading file');
              });
            } else {
              this.downloadService.setOpen(false);
              this.toastr.error('Tải file không thành công');
            }
          }, err => {
            this.downloadService.setOpen(false);
            this.toastr.error(err && err.message ? err.message : 'Error fetching download key');
          });
        } else if (data.menuContract === EnumDownloadMenuName.LABOR_CONTRACT || data.isLaborContractDownload) {
          this.isEmployeeDownload = false;
          this.isLaborContractDownload = true;
          this.laborContractName = data.laborContractName || '';
          this.downloadService.setOpen(true);
        } else {
          this.isEmployeeDownload = false;
          this.isLaborContractDownload = false;
          this.downloadService.setOpen(true);
          this.apiMultiDownloadService = this.documentService.preDownloadMultiFileZip(data).subscribe(response => {
            this.downloadService.setOpen(false);
            if (response) {
              if (response.success === false) {
                this.toastr.error(response.message, '', { positionClass: 'toast-bottom-right' });
              } else if (typeof response === 'string') {
                this.documentService.downloadMultiFileZip(response, data.isDigital);
              }
            }
          });
        }
      }
    });

    this.subscribeOpenDownloadService = this.downloadService._open$.subscribe(status => {
      this.isDownloadPopup = status;
      this.downloadService.setBlocking(status);
      if (!status) {
        this.isEmployeeDownload = false;
        this.isLaborContractDownload = false;
        this.employeeName = '';
        this.employeeProfileCount = 0;
        this.laborContractName = '';
        this.downloadService.clearData();
        this.apiMultiDownloadService && this.apiMultiDownloadService.unsubscribe();
      }
    });
  }

  async receiveMessage(event: any) {
    const message = event.data;

    if (message == 'logout') {

      await this.auth.logout();
      window.location.href = '/enterprise-login';
    }
  }

  setNameMenu(nameMenuContract: string) {
    switch (nameMenuContract) {
      case EnumDownloadMenuName.SEARCH_DOCUMENT:
        return this.nameMenu = 'download_popup.search_document';
      case EnumDownloadMenuName.SEARCH_DOCUMENT_RECEIVE:
        return this.nameMenu = 'download_popup.search_document_receive';
      case EnumDownloadMenuName.LIST_CONTRACT_BUSINESS:
        return this.nameMenu = 'download_popup.list_contract_business';
      case EnumDownloadMenuName.SEARCH_DOCUMENT_MINE:
        return this.nameMenu = 'download_popup.search_document_mine';
      case EnumDownloadMenuName.SEARCH_DOCUMENT_MINE_RECEIVE:
        return this.nameMenu = 'download_popup.search_document_mine_receive';
      case EnumDownloadMenuName.SEARCH_DOCUMENT_SIGN:
        return this.nameMenu = 'download_popup.search_document_sign';
      case EnumDownloadMenuName.SEARCH_DOCUMENT_SIGN_APPROVE:
        return this.nameMenu = 'download_popup.search_document_sign_approve';
      case EnumDownloadMenuName.SEARCH_DOCUMENT_SIGN_INITIAL:
        return this.nameMenu = 'download_popup.search_document_sign_initial';
      case EnumDownloadMenuName.LIST_CONTRACT:
        return this.nameMenu = 'download_popup.list_contract';
      default:
        return this.nameMenu = '';
    }
  }

  handleCloseDownload() {
    this.downloadService.setOpen(false);
  }

  private getFileName(disposition: string): string {
    if (!disposition) {
      return 'download.zip';
    }

    const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
    if (utf8Match) {
      return decodeURIComponent(utf8Match[1]);
    }

    const normalMatch = /filename=\"?([^\";]+)\"?/i.exec(disposition);
    return normalMatch ? normalMatch[1] : 'download.zip';
  }

  ngOnDestroy() {
    this.subscribeMultiDownloadService && this.subscribeMultiDownloadService.unsubscribe();
    this.subscribeOpenDownloadService && this.subscribeOpenDownloadService.unsubscribe();
  }
}
